import shaka from 'shaka-player';
import AdsStats from './AdsStats.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _adContainer, _networkingEngine, _video, _player, _isLive, _snapForwardTime, _adBreaks, _playedAds, _ad, _mediaTailorAd, _mediaTailorAdBreak, _staticResources, _adListeners, _eventsSent, _trackingUrl, _firstTrackingRequest, _eventManager, _stats, _onEvent, onEvent_fn, _requestTrackingInfo, requestTrackingInfo_fn, _requestAllStaticResources, requestAllStaticResources_fn, _requestStaticResource, requestStaticResource_fn, _setupAdBreakListeners, setupAdBreakListeners_fn, _checkForSnapback, checkForSnapback_fn, _findAdForSnapback, findAdForSnapback_fn, _onAdBreakEnded, onAdBreakEnded_fn, _onTimeupdate, onTimeupdate_fn, _sendInProgressEvents, sendInProgressEvents_fn, _checkLinearAds, checkLinearAds_fn, _checkLinearAdsOnAdBreak, checkLinearAdsOnAdBreak_fn, _checkNonLinearAds, checkNonLinearAds_fn, _checkNonLinearAdsOnAdBreak, checkNonLinearAdsOnAdBreak_fn, _displayNonLinearAd, displayNonLinearAd_fn, _onEnded, onEnded_fn, _setupCurrentAdListeners, setupCurrentAdListeners_fn, _removeCurrentAdListeners, removeCurrentAdListeners_fn, _sendTrackingEvent, sendTrackingEvent_fn;
const {
  ads: { AdManager, MediaTailorAd },
  net: { NetworkingEngine },
  util: {
    FakeEvent,
    EventManager,
    StringUtils
  }
} = shaka;
const _MediaTailorAdManager = class _MediaTailorAdManager extends AdManager {
  constructor() {
    super(...arguments);
    /**
     * @param {FakeEvent} event
     */
    __privateAdd(this, _onEvent);
    /**
     * @param {string} url
     * @param {boolean} firstRequest
     */
    __privateAdd(this, _requestTrackingInfo);
    __privateAdd(this, _requestAllStaticResources);
    /**
     * @param {mediaTailor.NonLinearAd} nonLinearAd
     */
    __privateAdd(this, _requestStaticResource);
    __privateAdd(this, _setupAdBreakListeners);
    /**
     * If a seek jumped over the ad break, return to the start of the
     * ad break, then complete the seek after the ad played through.
     */
    __privateAdd(this, _checkForSnapback);
    /**
     * @returns {{ previousAd: mediaTailor.Ad, previousAdBreak: mediaTailor.AdBreak }}
     */
    __privateAdd(this, _findAdForSnapback);
    __privateAdd(this, _onAdBreakEnded);
    __privateAdd(this, _onTimeupdate);
    /**
     * @param {number} currentTime
     * @param {mediaTailor.Ad} ad
     */
    __privateAdd(this, _sendInProgressEvents);
    /**
     * @param {number} currentTime
     */
    __privateAdd(this, _checkLinearAds);
    /**
     * @param {mediaTailor.AdBreak} adbreak
     * @param {number} currentTime
     * @returns {boolean} True if we should not check next adbreaks
     */
    __privateAdd(this, _checkLinearAdsOnAdBreak);
    /**
     * @param {number} currentTime
     */
    __privateAdd(this, _checkNonLinearAds);
    /**
     * @param {mediaTailor.AdBreak} adbreak
     * @param {number} currentTime
     */
    __privateAdd(this, _checkNonLinearAdsOnAdBreak);
    /**
     * @param {mediaTailorExternalResource.App[]} apps
     */
    __privateAdd(this, _displayNonLinearAd);
    __privateAdd(this, _onEnded);
    __privateAdd(this, _setupCurrentAdListeners);
    __privateAdd(this, _removeCurrentAdListeners);
    /**
     * @param {string} eventType
     * @private
     */
    __privateAdd(this, _sendTrackingEvent);
    /** @type {HTMLElement} */
    __privateAdd(this, _adContainer, void 0);
    /** @type {shaka.net.NetworkingEngine} */
    __privateAdd(this, _networkingEngine, void 0);
    /** @type {HTMLMediaElement} */
    __privateAdd(this, _video, void 0);
    /** @type {shaka.Player} */
    __privateAdd(this, _player, void 0);
    /** @type {boolean} */
    __privateAdd(this, _isLive, false);
    /**
     * Time to seek to after an ad if that ad was played as the result of
     * snapback.
     * @type {number}
     */
    __privateAdd(this, _snapForwardTime, void 0);
    /** @type {mediaTailor.AdBreak[]} */
    __privateAdd(this, _adBreaks, []);
    /** @type {string[]} */
    __privateAdd(this, _playedAds, []);
    /** @type {MediaTailorAd} */
    __privateAdd(this, _ad, void 0);
    /** @type {mediaTailor.Ad} */
    __privateAdd(this, _mediaTailorAd, void 0);
    /** @type {mediaTailor.AdBreak} */
    __privateAdd(this, _mediaTailorAdBreak, void 0);
    /** @type {Map.<string,mediaTailorExternalResource.App[]>} */
    __privateAdd(this, _staticResources, /* @__PURE__ */ new Map());
    /**
     * @type {{target: EventTarget, type: string, listener: shaka.util.EventManager.ListenerType}[]}
     */
    __privateAdd(this, _adListeners, []);
    /** @type {string[]} */
    __privateAdd(this, _eventsSent, []);
    /** @type {string} */
    __privateAdd(this, _trackingUrl, "");
    /** @type {boolean} */
    __privateAdd(this, _firstTrackingRequest, true);
    /** @type {shaka.util.EventManager} */
    __privateAdd(this, _eventManager, new EventManager());
    /** @type {AdsStats} */
    __privateAdd(this, _stats, new AdsStats());
  }
  /**
   * @param {HTMLElement} adContainer
   * @param {shaka.net.NetworkingEngine} networkingEngine
   * @param {HTMLMediaElement} video
   * @param {shaka.Player} player
   */
  initCustomMediaTailor(adContainer, networkingEngine, video, player) {
    __privateSet(this, _adContainer, adContainer);
    __privateSet(this, _networkingEngine, networkingEngine);
    __privateSet(this, _video, video);
    __privateSet(this, _player, player);
  }
  stop() {
    for (const listener of __privateGet(this, _adListeners)) {
      __privateGet(this, _eventManager).unlisten(listener.target, listener.type, listener.listener);
    }
    __privateMethod(this, _onEnded, onEnded_fn).call(this);
    __privateSet(this, _adListeners, []);
    __privateSet(this, _eventsSent, []);
    __privateSet(this, _trackingUrl, "");
    __privateSet(this, _firstTrackingRequest, true);
    __privateSet(this, _snapForwardTime, void 0);
    __privateSet(this, _adBreaks, []);
    __privateSet(this, _playedAds, []);
    __privateGet(this, _staticResources).clear();
  }
  release() {
    this.stop();
    if (__privateGet(this, _eventManager)) {
      __privateGet(this, _eventManager).release();
    }
    __privateSet(this, _adContainer, void 0);
    __privateSet(this, _networkingEngine, void 0);
    __privateSet(this, _video, void 0);
    __privateSet(this, _player, void 0);
  }
  onAssetUnload() {
    this.stop();
    __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_STOPPED));
    __privateSet(this, _stats, new AdsStats());
  }
  /**
   * @param {boolean} isLive
   */
  onManifestUpdated(isLive) {
    __privateSet(this, _isLive, isLive);
    if (__privateGet(this, _trackingUrl)) {
      __privateMethod(this, _requestTrackingInfo, requestTrackingInfo_fn).call(this, __privateGet(this, _trackingUrl), __privateGet(this, _firstTrackingRequest));
      __privateSet(this, _firstTrackingRequest, false);
    }
  }
  /**
   * @returns {shaka.extern.AdCuePoint[]}
   */
  getCuePoints() {
    const cuePoints = [];
    for (const adbreak of __privateGet(this, _adBreaks)) {
      for (const ad of adbreak.ads) {
        const cuePoint = {
          start: ad.startTimeInSeconds,
          end: ad.startTimeInSeconds + ad.durationInSeconds
        };
        cuePoints.push(cuePoint);
      }
    }
    return cuePoints;
  }
  /**
   * @return {shaka.extern.AdsStats}
   */
  getStats() {
    return __privateGet(this, _stats).getBlob();
  }
  /**
   * Set the tracking URL for the object.
   * @param {string} url - The URL to set for tracking
   */
  setTrackingUrl(url) {
    __privateSet(this, _trackingUrl, url);
    __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.ADS_LOADED));
  }
  /**
   * Check if the object has a tracking URL.
   * @return {boolean} true if the object has a tracking URL, false otherwise
   */
  hasTrackingUrl() {
    return !!__privateGet(this, _trackingUrl);
  }
};
_adContainer = new WeakMap();
_networkingEngine = new WeakMap();
_video = new WeakMap();
_player = new WeakMap();
_isLive = new WeakMap();
_snapForwardTime = new WeakMap();
_adBreaks = new WeakMap();
_playedAds = new WeakMap();
_ad = new WeakMap();
_mediaTailorAd = new WeakMap();
_mediaTailorAdBreak = new WeakMap();
_staticResources = new WeakMap();
_adListeners = new WeakMap();
_eventsSent = new WeakMap();
_trackingUrl = new WeakMap();
_firstTrackingRequest = new WeakMap();
_eventManager = new WeakMap();
_stats = new WeakMap();
_onEvent = new WeakSet();
onEvent_fn = function(event) {
  if (event && event.type) {
    switch (event.type) {
      case AdManager.AD_STARTED: {
        __privateGet(this, _stats).incrementStarted();
        break;
      }
      case AdManager.AD_COMPLETE: {
        __privateGet(this, _stats).incrementPlayedCompletely();
        break;
      }
      case AdManager.AD_SKIPPED: {
        __privateGet(this, _stats).incrementSkipped();
        break;
      }
    }
  }
  this.dispatchEvent(event);
};
_requestTrackingInfo = new WeakSet();
requestTrackingInfo_fn = async function(trackingUrl, firstRequest) {
  const type = NetworkingEngine.RequestType.ADS;
  const request = NetworkingEngine.makeRequest(
    [trackingUrl],
    NetworkingEngine.defaultRetryParameters()
  );
  const op = __privateGet(this, _networkingEngine).request(type, request);
  try {
    const response = await op.promise;
    let cuepoints = [];
    const data = StringUtils.fromUTF8(response.data);
    const dataAsJson = (
      /** @type {!mediaTailor.TrackingResponse} */
      JSON.parse(data)
    );
    if (dataAsJson.avails.length > 0) {
      if (JSON.stringify(__privateGet(this, _adBreaks)) !== JSON.stringify(dataAsJson.avails)) {
        __privateSet(this, _adBreaks, dataAsJson.avails);
        __privateMethod(this, _requestAllStaticResources, requestAllStaticResources_fn).call(this);
        cuepoints = this.getCuePoints();
        __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(
          AdManager.CUEPOINTS_CHANGED,
          (/* @__PURE__ */ new Map()).set("cuepoints", cuepoints)
        ));
      }
    } else {
      if (__privateGet(this, _adBreaks).length > 0) {
        __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(
          AdManager.CUEPOINTS_CHANGED,
          (/* @__PURE__ */ new Map()).set("cuepoints", cuepoints)
        ));
      }
      __privateMethod(this, _onEnded, onEnded_fn).call(this);
      __privateSet(this, _adBreaks, []);
    }
    if (firstRequest && (__privateGet(this, _isLive) || cuepoints.length > 0)) {
      __privateMethod(this, _setupAdBreakListeners, setupAdBreakListeners_fn).call(this);
    }
  } catch {
  }
};
_requestAllStaticResources = new WeakSet();
requestAllStaticResources_fn = function() {
  for (const adbreak of __privateGet(this, _adBreaks)) {
    for (const nonLinearAd of adbreak.nonLinearAdsList) {
      for (const nonLinearAdResource of nonLinearAd.nonLinearAdList) {
        __privateMethod(this, _requestStaticResource, requestStaticResource_fn).call(this, nonLinearAdResource);
      }
    }
  }
};
_requestStaticResource = new WeakSet();
requestStaticResource_fn = async function(nonLinearAd) {
  if (!nonLinearAd.staticResource) {
    return;
  }
  const cacheKey = getCacheKeyForNonLinear(nonLinearAd);
  const staticResource = __privateGet(this, _staticResources).get(cacheKey);
  if (staticResource) {
    return;
  }
  const type = NetworkingEngine.RequestType.ADS;
  const request = NetworkingEngine.makeRequest(
    [nonLinearAd.staticResource],
    NetworkingEngine.defaultRetryParameters()
  );
  const op = __privateGet(this, _networkingEngine).request(type, request);
  try {
    __privateGet(this, _staticResources).set(cacheKey, []);
    const response = await op.promise;
    const data = StringUtils.fromUTF8(response.data);
    const dataAsJson = (
      /** @type {!mediaTailorExternalResource.Response} */
      JSON.parse(data)
    );
    const { apps } = dataAsJson;
    __privateGet(this, _staticResources).set(cacheKey, apps);
  } catch {
    __privateGet(this, _staticResources).delete(cacheKey);
  }
};
_setupAdBreakListeners = new WeakSet();
setupAdBreakListeners_fn = function() {
  __privateMethod(this, _onTimeupdate, onTimeupdate_fn).call(this);
  if (!__privateGet(this, _isLive)) {
    __privateMethod(this, _checkForSnapback, checkForSnapback_fn).call(this);
    __privateGet(this, _eventManager).listen(__privateGet(this, _video), "seeked", () => {
      __privateMethod(this, _checkForSnapback, checkForSnapback_fn).call(this);
    });
    __privateGet(this, _eventManager).listen(__privateGet(this, _video), "ended", () => {
      __privateMethod(this, _onEnded, onEnded_fn).call(this);
    });
  }
  __privateGet(this, _eventManager).listen(__privateGet(this, _video), "timeupdate", () => {
    __privateMethod(this, _onTimeupdate, onTimeupdate_fn).call(this);
  });
};
_checkForSnapback = new WeakSet();
checkForSnapback_fn = function() {
  const { currentTime } = __privateGet(this, _video);
  if (currentTime === 0 || __privateGet(this, _snapForwardTime) !== void 0) {
    return;
  }
  const { previousAd, previousAdBreak } = __privateMethod(this, _findAdForSnapback, findAdForSnapback_fn).call(this);
  if (previousAdBreak && previousAd && !__privateGet(this, _playedAds).includes(previousAd.adId)) {
    __privateSet(this, _snapForwardTime, currentTime);
    __privateGet(this, _video).currentTime = previousAdBreak.startTimeInSeconds;
  }
};
_findAdForSnapback = new WeakSet();
findAdForSnapback_fn = function() {
  const { currentTime } = __privateGet(this, _video);
  let previousAdBreak;
  let previousAd;
  for (const adbreak of __privateGet(this, _adBreaks)) {
    for (const ad of adbreak.ads) {
      if (!previousAd) {
        if (ad.startTimeInSeconds < currentTime) {
          previousAd = ad;
          previousAdBreak = adbreak;
        }
      } else if (ad.startTimeInSeconds < currentTime && ad.startTimeInSeconds > previousAd.startTimeInSeconds + previousAd.durationInSeconds) {
        previousAd = ad;
        previousAdBreak = adbreak;
        break;
      }
    }
  }
  return { previousAd, previousAdBreak };
};
_onAdBreakEnded = new WeakSet();
onAdBreakEnded_fn = function() {
  const { currentTime } = __privateGet(this, _video);
  if (__privateGet(this, _snapForwardTime) && __privateGet(this, _snapForwardTime) > currentTime) {
    __privateGet(this, _video).currentTime = __privateGet(this, _snapForwardTime);
  }
  __privateSet(this, _snapForwardTime, void 0);
};
_onTimeupdate = new WeakSet();
onTimeupdate_fn = function() {
  if (!__privateGet(this, _video).duration) {
    return;
  }
  if (!__privateGet(this, _ad) && __privateGet(this, _adBreaks).length === 0) {
    return;
  }
  const { currentTime } = __privateGet(this, _video);
  let previousAd = false;
  if (__privateGet(this, _ad)) {
    previousAd = true;
    __privateMethod(this, _sendInProgressEvents, sendInProgressEvents_fn).call(this, currentTime, __privateGet(this, _mediaTailorAd));
    const remainingTime = __privateGet(this, _ad).getRemainingTime();
    const duration = __privateGet(this, _ad).getDuration();
    if (duration > 0 && (remainingTime <= 0 || remainingTime > duration)) {
      __privateMethod(this, _onEnded, onEnded_fn).call(this);
    }
  }
  if (!__privateGet(this, _ad) || !__privateGet(this, _ad).isLinear()) {
    __privateMethod(this, _checkLinearAds, checkLinearAds_fn).call(this, currentTime);
    if (!__privateGet(this, _ad)) {
      __privateMethod(this, _checkNonLinearAds, checkNonLinearAds_fn).call(this, currentTime);
    }
    if (previousAd && !__privateGet(this, _ad)) {
      __privateMethod(this, _onAdBreakEnded, onAdBreakEnded_fn).call(this);
    }
  }
};
_sendInProgressEvents = new WeakSet();
sendInProgressEvents_fn = function(currentTime, ad) {
  const firstQuartileTime = ad.startTimeInSeconds + 0.25 * ad.durationInSeconds;
  const midpointTime = ad.startTimeInSeconds + 0.5 * ad.durationInSeconds;
  const thirdQuartileTime = ad.startTimeInSeconds + 0.75 * ad.durationInSeconds;
  if (currentTime >= firstQuartileTime && !__privateGet(this, _eventsSent).includes(_MediaTailorAdManager.Event.FIRSTQUARTILE)) {
    __privateGet(this, _eventsSent).push(_MediaTailorAdManager.Event.FIRSTQUARTILE);
    __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.FIRSTQUARTILE);
  } else if (currentTime >= midpointTime && !__privateGet(this, _eventsSent).includes(_MediaTailorAdManager.Event.MIDPOINT)) {
    __privateGet(this, _eventsSent).push(_MediaTailorAdManager.Event.MIDPOINT);
    __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.MIDPOINT);
  } else if (currentTime >= thirdQuartileTime && !__privateGet(this, _eventsSent).includes(_MediaTailorAdManager.Event.THIRDQUARTILE)) {
    __privateGet(this, _eventsSent).push(_MediaTailorAdManager.Event.THIRDQUARTILE);
    __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.THIRDQUARTILE);
  }
};
_checkLinearAds = new WeakSet();
checkLinearAds_fn = function(currentTime) {
  for (const adbreak of __privateGet(this, _adBreaks)) {
    if (__privateGet(this, _ad) && __privateGet(this, _ad).isLinear()) {
      break;
    }
    if (__privateMethod(this, _checkLinearAdsOnAdBreak, checkLinearAdsOnAdBreak_fn).call(this, adbreak, currentTime))
      return;
  }
};
_checkLinearAdsOnAdBreak = new WeakSet();
checkLinearAdsOnAdBreak_fn = function(adbreak, currentTime) {
  for (let i = 0; i < adbreak.ads.length; i += 1) {
    const ad = adbreak.ads[i];
    const startTime = ad.startTimeInSeconds;
    const endTime = ad.startTimeInSeconds + ad.durationInSeconds;
    if (startTime <= currentTime && endTime > currentTime) {
      if (__privateGet(this, _playedAds).includes(ad.adId)) {
        if (__privateGet(this, _video).ended) {
          continue;
        }
        __privateGet(this, _video).currentTime = endTime;
        return true;
      }
      __privateMethod(this, _onEnded, onEnded_fn).call(this);
      __privateSet(this, _mediaTailorAdBreak, adbreak);
      __privateSet(this, _ad, new MediaTailorAd(
        ad,
        /* adPosition= */
        i + 1,
        /* totalAds= */
        adbreak.ads.length,
        /* isLinear= */
        true,
        __privateGet(this, _video)
      ));
      __privateSet(this, _mediaTailorAd, ad);
      if (i === 0) {
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.BREAKSTART);
      }
      __privateMethod(this, _setupCurrentAdListeners, setupCurrentAdListeners_fn).call(this);
      break;
    }
  }
  return false;
};
_checkNonLinearAds = new WeakSet();
checkNonLinearAds_fn = function(currentTime) {
  for (const adbreak of __privateGet(this, _adBreaks)) {
    if (__privateGet(this, _ad)) {
      break;
    }
    __privateMethod(this, _checkNonLinearAdsOnAdBreak, checkNonLinearAdsOnAdBreak_fn).call(this, adbreak, currentTime);
  }
};
_checkNonLinearAdsOnAdBreak = new WeakSet();
checkNonLinearAdsOnAdBreak_fn = function(adbreak, currentTime) {
  for (let i = 0; i < adbreak.nonLinearAdsList.length; i += 1) {
    const ad = adbreak.nonLinearAdsList[i];
    if (ad.nonLinearAdList.length === 0) {
      continue;
    }
    const startTime = adbreak.startTimeInSeconds;
    const cacheKey = getCacheKeyForNonLinear(ad.nonLinearAdList[0]);
    const staticResource = __privateGet(this, _staticResources).get(cacheKey);
    if (startTime <= currentTime && staticResource && staticResource.length > 0) {
      __privateMethod(this, _onEnded, onEnded_fn).call(this);
      __privateMethod(this, _displayNonLinearAd, displayNonLinearAd_fn).call(this, staticResource);
      __privateSet(this, _mediaTailorAdBreak, adbreak);
      __privateSet(this, _ad, new MediaTailorAd(
        ad,
        /* adPosition= */
        i + 1,
        /* totalAds= */
        adbreak.ads.length,
        /* isLinear= */
        false,
        __privateGet(this, _video)
      ));
      __privateSet(this, _mediaTailorAd, ad);
      if (i === 0) {
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.BREAKSTART);
      }
      __privateMethod(this, _setupCurrentAdListeners, setupCurrentAdListeners_fn).call(this);
      break;
    }
  }
};
_displayNonLinearAd = new WeakSet();
displayNonLinearAd_fn = function(apps) {
  for (const app of apps) {
    if (app.data.source.length === 0) {
      continue;
    }
    const imageElement = (
      /** @type {!HTMLImageElement} */
      document.createElement("img")
    );
    imageElement.src = app.data.source[0].url;
    imageElement.style.top = `${app.placeholder.top || 0}%`;
    imageElement.style.height = `${100 - (app.placeholder.top || 0)}%`;
    imageElement.style.left = `${app.placeholder.left || 0}%`;
    imageElement.style.maxWidth = `${100 - (app.placeholder.left || 0)}%`;
    imageElement.style.objectFit = "contain";
    imageElement.style.position = "absolute";
    __privateGet(this, _adContainer).append(imageElement);
  }
};
_onEnded = new WeakSet();
onEnded_fn = function() {
  if (__privateGet(this, _ad)) {
    while (__privateGet(this, _adContainer).lastChild) {
      __privateGet(this, _adContainer).firstChild.remove();
    }
    if (!__privateGet(this, _isLive)) {
      __privateGet(this, _playedAds).push(__privateGet(this, _mediaTailorAd).adId);
    }
    __privateMethod(this, _removeCurrentAdListeners, removeCurrentAdListeners_fn).call(this);
    const position = __privateGet(this, _ad).getPositionInSequence();
    const totalAdsInBreak = __privateGet(this, _ad).getSequenceLength();
    if (position === totalAdsInBreak) {
      __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.BREAKEND);
    }
    __privateSet(this, _ad, void 0);
    __privateSet(this, _mediaTailorAd, void 0);
    __privateSet(this, _mediaTailorAdBreak, void 0);
  }
};
_setupCurrentAdListeners = new WeakSet();
setupCurrentAdListeners_fn = function() {
  let needFirstEvents = false;
  if (__privateGet(this, _video).paused) {
    needFirstEvents = true;
  } else {
    __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.IMPRESSION);
    __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.START);
  }
  __privateGet(this, _adListeners).push({
    target: __privateGet(this, _video),
    type: "volumechange",
    listener: () => {
      if (__privateGet(this, _video).muted) {
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.MUTE);
      }
    }
  }, {
    target: __privateGet(this, _video),
    type: "volumechange",
    listener: () => {
      if (!__privateGet(this, _video).muted) {
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.UNMUTE);
      }
    }
  }, {
    target: __privateGet(this, _video),
    type: "play",
    listener: () => {
      if (needFirstEvents) {
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.IMPRESSION);
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.START);
        needFirstEvents = false;
      } else {
        __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.RESUME);
      }
    }
  }, {
    target: __privateGet(this, _video),
    type: "pause",
    listener: () => {
      __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.PAUSE);
    }
  }, {
    target: __privateGet(this, _player),
    type: "buffering",
    listener: (event) => {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent("ad-buffering", (/* @__PURE__ */ new Map()).set("buffering", event.buffering)));
    }
  });
  for (const listener of __privateGet(this, _adListeners)) {
    __privateGet(this, _eventManager).listen(listener.target, listener.type, listener.listener);
  }
};
_removeCurrentAdListeners = new WeakSet();
removeCurrentAdListeners_fn = function() {
  __privateMethod(this, _sendTrackingEvent, sendTrackingEvent_fn).call(this, _MediaTailorAdManager.Event.COMPLETE);
  for (const listener of __privateGet(this, _adListeners)) {
    __privateGet(this, _eventManager).unlisten(listener.target, listener.type, listener.listener);
  }
  __privateSet(this, _adListeners, []);
  __privateSet(this, _eventsSent, []);
};
_sendTrackingEvent = new WeakSet();
sendTrackingEvent_fn = function(eventType) {
  switch (eventType) {
    case _MediaTailorAdManager.Event.IMPRESSION: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_IMPRESSION));
      break;
    }
    case _MediaTailorAdManager.Event.START: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(
        AdManager.AD_STARTED,
        (/* @__PURE__ */ new Map()).set("ad", __privateGet(this, _ad))
      ));
      break;
    }
    case _MediaTailorAdManager.Event.MUTE: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_MUTED));
      break;
    }
    case _MediaTailorAdManager.Event.UNMUTE: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_VOLUME_CHANGED));
      break;
    }
    case _MediaTailorAdManager.Event.RESUME: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_RESUMED));
      break;
    }
    case _MediaTailorAdManager.Event.PAUSE: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_PAUSED));
      break;
    }
    case _MediaTailorAdManager.Event.FIRSTQUARTILE: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_FIRST_QUARTILE));
      break;
    }
    case _MediaTailorAdManager.Event.MIDPOINT: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_MIDPOINT));
      break;
    }
    case _MediaTailorAdManager.Event.THIRDQUARTILE: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_THIRD_QUARTILE));
      break;
    }
    case _MediaTailorAdManager.Event.COMPLETE: {
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_COMPLETE));
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(AdManager.AD_STOPPED));
      break;
    }
    case _MediaTailorAdManager.Event.BREAKSTART: {
      __privateGet(this, _adContainer).setAttribute("ad-active", "true");
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(_MediaTailorAdManager.Event.BREAKSTART));
      break;
    }
    case _MediaTailorAdManager.Event.BREAKEND: {
      __privateGet(this, _adContainer).removeAttribute("ad-active");
      __privateMethod(this, _onEvent, onEvent_fn).call(this, new FakeEvent(_MediaTailorAdManager.Event.BREAKEND));
      break;
    }
  }
};
/** @enum {string} */
__publicField(_MediaTailorAdManager, "Event", {
  IMPRESSION: "impression",
  START: "start",
  MUTE: "mute",
  UNMUTE: "unmute",
  RESUME: "resume",
  PAUSE: "pause",
  FIRSTQUARTILE: "firstQuartile",
  MIDPOINT: "midpoint",
  THIRDQUARTILE: "thirdQuartile",
  COMPLETE: "complete",
  BREAKSTART: "breakStart",
  BREAKEND: "breakEnd"
});
let MediaTailorAdManager = _MediaTailorAdManager;
function getCacheKeyForNonLinear(nonLinearAd) {
  return [
    nonLinearAd.adId,
    nonLinearAd.adParameters,
    nonLinearAd.adSystem,
    nonLinearAd.adTitle,
    nonLinearAd.creativeAdId,
    nonLinearAd.creativeId,
    nonLinearAd.creativeSequence,
    nonLinearAd.height,
    nonLinearAd.width,
    nonLinearAd.staticResource
  ].join("");
}

export { MediaTailorAdManager as default };
//# sourceMappingURL=MediaTailorAdManager.js.map
